import { Controller } from "@hotwired/stimulus"

// Kept only in memory, never local/session storage.
let draft = null
let draftSource = null

export default class extends Controller {
  static targets = ["form", "heading", "errors"]
  static values = { submitted: Boolean }

  connect() {
    if (this.submittedValue) {
      draft = null
    } else if (this.hasFormTarget && draft && !this.hasErrorsTarget) {
      const source = this.formTarget.elements.namedItem("sales_enquiry[source]").value
      for (const [name, value] of Object.entries(draft)) {
        if (name === "sales_enquiry[interest]" && source !== draftSource) continue
        this.formTarget.elements.namedItem(name).value = value
      }
    }
    const focusTarget = this.hasErrorsTarget ? this.errorsTarget : this.headingTarget
    focusTarget.focus({ preventScroll: true })
  }

  remember() {
    draftSource = this.formTarget.elements.namedItem("sales_enquiry[source]").value
    draft = {}
    for (const name of ["name", "email", "company", "country_code", "interest", "message"]) {
      const key = `sales_enquiry[${name}]`
      draft[key] = this.formTarget.elements.namedItem(key).value
    }
  }
}
